module.exports = __webpack_public_path__ + "img/9.c391ad37.gif";